// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"a6ea2c9a","548":"a6ea2c9a"}[chunkId] + ".chunk.css";
};